import { isZh } from "../utils/language";
import { apiFetch } from "../utils/wkCommon";
import GearIcon from "./_icons";
import AgendaCrossNavMenu from "./AgendaCrossNavMenu";

export default function AgendaBookHeaderActions({
  agendaBookReady,
	hasPreRegForm = false,
  showMenu,
  setShowMenu,
  canSaveTemplate,

  setTemplates,
  setSelectedTemplateId,
  setTemplateZh,
  setTemplateId,
  setSaveMode,

  setShowSaveModal,
  setShowLoadModal,
  setShowAttrModal,

  id,
  history
}) {

	async function handleOpenSave() {
		const resp = await apiFetch("/api/agenda-book-templates");
		setTemplates(resp?.data || resp || []);
		setSaveMode("new");
		setSelectedTemplateId("");
		setTemplateZh("");
		setTemplateId("");
		setShowSaveModal(true);
	}

	async function handleOpenLoad() {
		const resp = await apiFetch("/api/agenda-book-templates");
		setTemplates(resp?.data || resp || []);
		setSelectedTemplateId("");
		setShowLoadModal(true);
	}

  return (
    <>
			<style>{`
				.ab-preview-btn {
					background: #ffffff;
					color: #1e293b;
					border: 1px solid #cbd5e1;
					border-radius: 0.5rem;
					padding: 0.45rem 0.9rem;
					font-size: 0.875rem;
					font-weight: 600;
					cursor: pointer;
					transition: all 0.15s ease;
				}

				.ab-preview-btn:hover {
					background: #f8fafc;
					border-color: #94a3b8;
				}
			`}</style>		
			<div className="ab-headeractions" style={{ display: "flex", gap: "0.5rem" }}>

				<button
					className="ab-preview-btn"
					onClick={() => window.open(`/abr/${id}`, "_blank")}
				>
					{isZh() ? "報表預覽" : "Preview Report"}
				</button>

				<div style={{ position: "relative", display: "flex", alignItems: "center", gap: "0.4rem" }}>
					<button
						className="btn-icon more-btn"
						onClick={()=>setShowMenu(s=>!s)}
					>
						⋯
					</button>

					{showMenu && (
						<div className="action-menu">

							<AgendaCrossNavMenu
								agendaId={id}
								hasPreRegForm={hasPreRegForm}
								onClose={() => setShowMenu(false)}
							/>

							<div style={{ margin: "0.5rem 0", borderBottom: "solid 1px #dedede" }} />

							{canSaveTemplate && (
								<div
									className="menu-item"
									onClick={handleOpenSave}
							>
									<div className="menu-label">{isZh() ? "保存為範本" : "Save as Template"}</div>
								</div>
							)}

							<div
								className="menu-item"
								onClick={handleOpenLoad}
							>
								<div className="menu-label">{isZh() ? "載入範本" : "Load Template"}</div>
							</div>

							<div style={{ margin: "0.5rem 0", borderBottom: "solid 1px #dedede" }}> </div>

							<div
								className="menu-item"
								onClick={()=>{
									setShowMenu(false);
									setShowAttrModal(true);
								}}
							>
								<div className="menu-icon"><GearIcon/></div>
								<div className="menu-label">Configuration</div>
							</div>

						</div>
					)}
				</div>
			</div>
    </>
  );
}